import React from 'react';
import { useEffect, useRef, useState } from 'react'
import {
  SDrawerOrModal,
} from 'shj-components'
import { Row, Col, Select, Switch, Button, message } from 'antd';
import { getChildrenDicts } from '@/services/index';
import { getByFlowKeyAndOrderld } from '@/services/order';
import styles from './index.module.less'

const refundTypeMap = {
  'REFUND_BACK_TRACK': '原路退回',
  'REFUND_OFFLINE': '财务线下退款',
}

const accountNatureMao = {
  'publicAccount': '对公',
  'privateAccount': '对私',
}

export default function DetailModal ({ editId = '', stateDisplay = '', open = false, onClose = () => {} })  {

  const [contentInfo, setContentInfo] = useState({});
  const [reasonStr, setReasonStr] = useState('');

  useEffect(() => {
    if (editId) {
      getDetail(editId);
    }
  }, [editId]);

  const getDetail = async (id) => {
    try {
      const res: any = await getByFlowKeyAndOrderld({
        params: {
          orderId: id,
          goodsId: editId,
          flowKey: 'TRADE_RETURN_RETAIL_WORK_FLOW',
        }
      });
      const dicRes = await getChildrenDicts(['BackMoneyReason']);
      if (res?.id) {
        setContentInfo(res);
      }
      const reasonList = dicRes?.[0]?.children?.map(item => ({ label: item.name, value: item.priKey }))
      if (res.reason) {
        const reasonItem = reasonList.find(item => item.value === res.reason);
        setReasonStr(reasonItem?.label || '');
      }
    } catch(err) {
      console.log(err)
    }
  }

  return (
    <div className={styles.detailModalBox}>
      <SDrawerOrModal
        title='详情'
        mode="drawer"
        open={open}
        onCancel={() => onClose()}
        width="60%"
        antdProps={{
          footer: ''
        }}
        isHideCancelBtn={true}
        okBtnDisabled={true}
      >
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={24} className={styles.colBox}>
            <span className={styles.titleBox}>进度：</span>
            <span className={styles.content}>{ stateDisplay }</span>
          </Col>
        </Row>
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={24} className={styles.colBox}>
            <span className={styles.titleBox}>退款方式：</span>
            <span className={styles.content}>{ refundTypeMap[(contentInfo as any)?.refundChannel] }</span>
          </Col>
        </Row>
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={24} className={styles.colBox}>
            <span className={styles.titleBox}>退款金额：</span>
            <span className={styles.content}>{ (contentInfo as any)?.refundAmount }</span>
          </Col>
        </Row>
        {
          (contentInfo as any)?.refundChannel === 'REFUND_OFFLINE' ? (
            <Row gutter={[15, 10]} className={styles.rowBox}>
              <Col span={24} className={styles.colBox}>
                <span className={styles.titleBox}>账户类型：</span>
                <span className={styles.content}>{ accountNatureMao[(contentInfo as any)?.accountNature] }</span>
              </Col>
            </Row>
          ) : null
        }
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={24} className={styles.colBox}>
            <span className={styles.titleBox}>客户开户名：</span>
            <span className={styles.content}>{ (contentInfo as any)?.accountName }</span>
          </Col>
        </Row>
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={24} className={styles.colBox}>
            <span className={styles.titleBox}>客户银行卡号：</span>
            <span className={styles.content}>{ (contentInfo as any)?.accountNumber }</span>
          </Col>
        </Row>
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={24} className={styles.colBox}>
            <span className={styles.titleBox}>客户银行网点：</span>
            <span className={styles.content}>{ (contentInfo as any)?.branchName }</span>
          </Col>
        </Row>
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={24} className={styles.colBox}>
            <span className={styles.titleBox}>退款原因：</span>
            <span className={styles.content}>{ reasonStr }</span>
          </Col>
        </Row>
        <Row gutter={[15, 10]} className={styles.rowBox}>
          <Col span={24} className={styles.colBox}>
            <span className={styles.titleBox}>是否退货：</span>
            <span className={styles.content}>{ (contentInfo as any)?.isReturnGoods === 1 ? '是' : '否' }</span>
          </Col>
        </Row>
      </SDrawerOrModal>
    </div>
  )
}